export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const SET_CURRENT_USER = "SET_CURRENT_USER";

export const GET_PROFILE = "GET_PROFILE";
export const PROFILE_LOADING = "PROFILE_LOADING";
export const CLEAR_CURRENT_PROFILE = "CLEAR_CURRENT_PROFILE";
export const GET_PROFILES = "GET_PROFILES";

export const POST_LOADING = "POST_LOADING";
export const GET_POSTS = "GET_POSTS";
export const GET_POST = "GET_POST";
export const ADD_POST = "ADD_POST";
export const DELETE_POST = "DELETE_POST";


export const LOADING = "LOADING";

export const GET_SHIPPING = "GET_SHIPPING";
export const ADD_SHIPPING = "ADD_SHIPPING";
export const UPDATE_SHIPPING = "UPDATE_SHIPPING";

export const GET_TRANSPORT = "GET_TRANSPORT";
export const SET_TRANSPORT = "SET_TRANSPORT";
export const GET_TRANSPORT_DATES = "GET_TRANSPORT_DATES";

export const GET_BRANCH = "GET_BRANCH";
export const ADD_BRANCH = "ADD_BRANCH";
export const UPDATE_BRANCH = "UPDATE_BRANCH";
export const REMOVE_BRANCH = "REMOVE_BRANCH";


export const GET_CONSIGNEE = "GET_CONSIGNEE";
export const ADD_CONSIGNEE = "ADD_CONSIGNEE";
export const UPDATE_CONSIGNEE = "UPDATE_CONSIGNEE";
export const REMOVE_CONSIGNEE = "REMOVE_CONSIGNEE";